module.exports = __webpack_public_path__ + "img/categorie-coffret-famille-boutrais.ed16f3b5.webp";